import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUserContext } from "../context/user-context";
import { appFetch } from "./app-fetch";

const getTrackingKey = (email: string, refTag: string, path: string) =>
  `tracked-ref-tag:${email}:${refTag}:${path}`;

const useCaptureRefTag = () => {
  const location = useLocation();
  const { userState, setStateUserState } = useUserContext();

  const refTag = new URLSearchParams(location.search).get("ref")?.trim() || "";

  useEffect(() => {
    if (!refTag) return;

    localStorage.setItem("referrer", refTag);

    if (userState?.attributes?.referrer !== refTag) {
      setStateUserState(prev => ({
        ...prev,
        attributes: { ...prev.attributes, referrer: refTag }
      }));
    }

    const token = localStorage.getItem("token");
    const email = userState?.attributes?.email;
    if (!token || !email) return;

    const path = `${location.pathname}${location.search}`;
    const trackingKey = getTrackingKey(email, refTag, path);
    if (sessionStorage.getItem(trackingKey)) return;

    sessionStorage.setItem(trackingKey, "1");

    appFetch("/api/auth/ref-tag", { method: "POST" }, { refTag, path }).catch(
      () => {
        sessionStorage.removeItem(trackingKey);
      }
    );
  }, [
    location.pathname,
    location.search,
    refTag,
    setStateUserState,
    userState?.attributes?.email,
    userState?.attributes?.referrer
  ]);
};

export default useCaptureRefTag;
